export const CommandItemTitle: React.FC<{
  label: string;
  unavailable?: string | null;
}> = ({ label, unavailable }) => {
  return (
    <span
      className={
        unavailable
          ? "text-muted-foreground line-through opacity-70"
          : undefined
      }
      title={unavailable ?? undefined}
    >
      {label.split(" / ").length > 2 ? (
        <>
          <span className="font-family-fancy text-foreground-5 text-xs">
            {label.split(" / ").slice(0, 2).join("/")}/
          </span>
          {label.split(" / ").slice(2).join("/")}
        </>
      ) : (
        label
      )}
    </span>
  );
};
